module.exports = __webpack_public_path__ + "62668118fc078d656ee1eb168df4ed7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/data-to-make-you-better/screens/mobile/ride.png
// module id = 1746
// module chunks = 1